export default __webpack_public_path__ + "static/web-development-753cc84b90e216c62476d8a14cb51d6b.png";